import styled, { keyframes } from "styled-components";
import { Play, VideoCircle } from "iconsax-react";

import rightCurveImage from "../../../../image/assets/hero-arrow-right.svg";
import leftCurveImage from "../../../../image/assets/hero-arrow-left.svg";

import heroStudentBgImg from "../../../../image/home/hero-student-bg.svg";

const curveBgImageWidth = 150;
const curveBgImageHeight = 150;

export const StyledSection = styled.section`
  padding-bottom: 7rem;
  @media screen and (max-width: 768px) {
    padding-bottom: 120px;
  }
  background-color: var(--tertiary-color);
  color: var(--white-color);
  position: relative;
  &:before,
  &:after {
    content: "";
    position: absolute;
  }
  &:before {
    background: url(${leftCurveImage}) no-repeat;
    top: 15px;
    left: 0;
    width: ${curveBgImageWidth}px;
    height: ${curveBgImageHeight}px;
  }
  &::after {
    background: url(${rightCurveImage}) no-repeat;
    bottom: 200px;
    right: 0;
    width: ${curveBgImageWidth}px;
    height: ${curveBgImageHeight}px;
  }
  @media screen and (max-width: 1200px) {
    &:before {
      top: 50px;
      width: ${curveBgImageWidth / 2}px;
      height: ${curveBgImageHeight / 1.5}px;
    }
    &::after {
      width: ${curveBgImageWidth / 2}px;
      height: ${curveBgImageHeight / 1.5}px;
      bottom: 15%;
    }
  }
  @media screen and (max-width: 767px) {
    &:before {
      top: 50px;
      width: ${curveBgImageWidth / 1.5}px;
      height: ${curveBgImageHeight / 1.5}px;
      transform: skewY(15deg);
    }
    &::after {
      width: ${curveBgImageWidth / 1.5}px;
      height: ${curveBgImageHeight / 1.5}px;
      transform: skewY(15deg) translateY(-40%);
      bottom: 50%;
    }
  }
  @media screen and (max-width: 576px) {
    &:before {
      top: 50px;
      width: 50px;
    }
    &::after {
      bottom: 36%;
      width: 50px;
    }
  }
`;

export const StyledHeroButton = styled.button`
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 0.5rem;
  border: 3px solid var(--secondary-color);
  border-radius: 16px;
  font-size: var(--font-size-lg);
  font-weight: 500;
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  white-space: nowrap;
  @media screen and (max-width: 1200px) {
    font-size: var(--font-size-base);
    padding: 7px 11px;
  }
  ${({ $shadow }) =>
    $shadow &&
    "box-shadow: 1px 6px 20px 4px rgba(247, 195, 2, 0.24), 0px 4px 20px 0px rgba(11, 69, 126, 0.05) inset"};
`;

export const StyledVideoCircle = styled(VideoCircle)`
  color: var(--tertiary-color);
  transform: rotate(180deg);
  @media screen and (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

export const PlayIcon = styled(Play)`
  transform: rotate(180deg);
  @media screen and (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

export const HeroContentWrapper = styled.div`
  padding-top: 6rem;
  row-gap: 26px;
  h2 {
    font-size: 32px;
    line-height: 50px;
    font-weight: 700;
  }
  p {
    font-size: var(--font-size-md);
    line-height: 28px;
    opacity: 0.7;
    strong {
      color: var(--secondary-color);
    }
  }
  @media screen and (max-width: 992px) {
    row-gap: 1rem;
    h2 {
      font-size: var(--font-size-lg);
      line-height: 40px;
    }
    p {
      font-size: var(--font-size-base);
      max-width: 280px;
    }
  }
  @media screen and (max-width: 576px) {
    padding-top: 3rem;
  }
`;

export const HeroButtonsWrapper = styled.div`
  justify-content: left;
  grid-gap: 1rem;
  @media screen and (max-width: 320px) {
    flex-wrap: wrap;
    button {
      width: 100%;
    }
  }
`;

const animation = keyframes`  
  0%{
    transform: rotate(0);
  }
  50%{
    transform: rotate(180);
  }
  100%{
    transform: rotate(360);
  }
`;
export const HeroBoyWrapper = styled.div`
  width: fit-content;
  margin-right: auto;
  padding-top: 4rem;
  position: relative;
  overflow: hidden;
  img {
    position: relative;
  }
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(${heroStudentBgImg}) no-repeat center;
    max-width: 540px;
    /* animation: ${animation} infinite linear 10s; */
    transition: all linear 10s;
  }
  &:hover::before {
    transform: rotate(360deg);
  }
`;
